
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 10.698v10.604h7.111L16 30.14V1.861l-8.889 8.837H0zM24 16c0-3.128-1.813-5.815-4.444-7.123v14.228C22.186 21.815 24 19.128 24 16zM19.556.5v3.64c5.137 1.52 8.888 6.257 8.888 11.86s-3.75 10.34-8.888 11.86v3.64C26.684 29.892 32 23.564 32 16S26.684 2.108 19.556.5z","fill":"currentColor"}})])
          )
        }
      }
    